import { render, staticRenderFns } from "./Data.vue?vue&type=template&id=b4c3919e&scoped=true&"
import script from "./Data.vue?vue&type=script&lang=js&"
export * from "./Data.vue?vue&type=script&lang=js&"
import style0 from "./Data.vue?vue&type=style&index=0&id=b4c3919e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c3919e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/regalstreak/development/web/souvenirsofconflict/souvenirsofconflict/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
